import { FACTIONS } from "@frontier/content/factions";
import { RELAY_PRESTIGE_TITLE } from "@frontier/content/relay";
import type { PublicEventView } from "@frontier/content/events";
import { relayStatus } from "./relay-ui";

export function RelayReadout({ event, presence }: { event: PublicEventView; presence?: number | undefined }) {
  if (event.type !== "relay") return null;
  const faction = event.capture?.factionId;
  return (
    <div className="relay-readout" aria-label="Контроль ретранслятора">
      <strong className="relay-risk">ОТКРЫТЫЙ PVP · РИСК ПОТЕРИ ГРУЗА</strong>
      <b style={{ color: faction ? FACTIONS[faction].color : undefined }}>{relayStatus(event)}</b>
      <span>
        {event.status === "available"
          ? "Захват — после появления сигнала."
          : `Удержание ${Math.floor(event.progress)} / ${event.goal} с · радиус ${event.capture?.radius ?? 0} м`}
      </span>
      {presence !== undefined && <span>Твоё присутствие при свободной точке: {Math.floor(presence)} с</span>}
      <small>
        Награда — живым участникам победившей фракции на точке к завершению.
        Постоянное звание «{RELAY_PRESTIGE_TITLE}» без бонуса к силе.
      </small>
    </div>
  );
}
